<template lang="pug">
    div
        Card.a8-page-description-card
            Row(type="flex" align="middle" justify="space-between")
                Col
                    h2 {{ $t('notificationChannels.pageTitleText') }}
                Col
                    ExplainBtn(:objectExplanation="objectsExplanation")
            p Create notification channels for receiving alert or other notification.
            strong You have created {{ usage.used }} of {{ usage.max }} notification channels.

        // h2 {{ $t('notificationChannels.pageTitleText') }}
        RcmTable(
            :esIndex="esIndex"
            :esIndexFields="esIndexFields"
            :addButtonText="addButtonText"
            :drawerTitleKey="drawerTitleKey"
            :userCanCreate="true"
            :userCanIndex="true"
            :userCanDelete="true"
            :actionInTable="true"
            :sort="sort"
            ref="rcmTable"
            :searchView="$options.name"
            :sectionInfo="sectionInfo"
            primarySearchKey="channelName"
            :primarySearchKeyI18="$t('notificationChannels.channelName')"
            :isCreateBtnDisabled="!$can('write', 'domainManagePermission','NotificationChannels')"
            :isEditBtnDisabled="!$can('write', 'domainManagePermission','NotificationChannels')"
            :isDeleteBtnDisabled="!$can('write', 'domainManagePermission','NotificationChannels')"
        )
</template>
<script>
import Vue from "vue";
Vue.component("ChannelTestBtn", ChannelTestBtn);

import RcmTable from "@/components/RcmTable_v2";
import ChannelTestBtn from "@/components/NotificationChannels/ChannelTestBtn";
import bus from "@/libs/bus.js";
import JsonPoptip from "@/components/JsonPoptip";
import ObjectLogBtn from "@/components/ObjectLogBtn";

Vue.component("JsonPoptip", JsonPoptip);
Vue.component("ObjectLogBtn", ObjectLogBtn);

import { getGroupAsset } from "@/api/groupasset.js";

import { settingZoneExplain, isEnabled } from "./fields.js";

export default {
    name: "NotificationChannels",
    components: { RcmTable, ChannelTestBtn },
    data() {
        return {
            esIndex: "rcm-notificationchannels",
            drawerTitleKey: "channelName",
            sort: [{ modifiedDate: { order: "desc" } }],
            assetCategory: "notificationChannels",
            usage: { used: "", max: "", available: "" },
            objectsExplanation: {},
        };
    },
    computed: {
        addButtonText() {
            return this.$i18n.t("domainsetting.createText");
        },
        sectionInfo() {
            let sectionInfo = [{ sectionKey: "essential", isOpened: true }];

            sectionInfo = sectionInfo.map((e) => {
                e.sectionName = this.$i18n.t(`notificationChannels.sections.${e.sectionKey}`);
                return e;
            });

            return sectionInfo;
        },
        esIndexFields() {
            return this.$store.getters.isAdmin
                ? {
                      action: {},
                      settingZoneExplain: settingZoneExplain(this),
                      groupName: {},
                      channelName: {},
                      _id: {},
                      channelType: {},
                      channelTelegramBotToken: {},
                      channelLineBotToken: {},
                      channelSendTo: {},
                      channelTest: {},
                      isenabled: isEnabled(this),
                      createdDate: {},
                      modifiedDate: {},
                      status: {},
                      objectLog: {},
                  }
                : {
                      action: {},
                      createBy: {},
                      settingZoneExplain: settingZoneExplain(this),
                      groupName: {},
                      channelName: {},
                      _id: {},
                      channelType: {},
                      channelTelegramBotToken: {},
                      channelLineBotToken: {},
                      channelSendTo: {},
                      channelTest: {},
                      isenabled: isEnabled(this),
                      createdDate: {},
                      modifiedDate: {},
                      status: {},
                      objectLog: {},
                  };
        },
    },
    watch: {
        "$i18n.locale": {
            deep: true,
            handler: function () {
                this.objectsExplanation = this.$i18n.t("objectExplanation." + this.esIndex);
            },
        },
    },
    methods: {
        getAssetData() {
            getGroupAsset({
                category: this.assetCategory,
                groupNames: [this.$store.state.queryGroupName],
            }).then((res) => {
                let { used, max } = res.data;
                let available = max - used;
                this.usage = { used, max, available };
            });
        },
    },
    mounted() {
        this.getAssetData();
    },
    created() {
        this.objectsExplanation = this.$i18n.t("objectExplanation." + this.esIndex);
        this.$bus = bus;
        // 監聽以自己組件為名的事件
        bus.$on(this.$options.name, (busEvent, args) => {
            // 如果是找我的事件就接收處理, 否則向下傳遞
            switch (busEvent) {
                case "":
                    break;
                default:
                    bus.$emit(busEvent);
                    break;
            }
        });
    },
    destroyed() {},
    beforeDestroy() {
        bus.$off(this.$options.name);
    },
};
</script>



// WEBPACK FOOTER //
// src/view/NotificationChannels/Page.vue